import axios from 'axios';
import { promiseJwt } from '@isyc-react/oc-api/auth/auth-jwt.utils';
export const dateAutoLogin = (form) => {
    const { p, bu, birthDate } = form;
    return promiseJwt(() => axios.get(`/api/public/user/auto/login?p=${encodeURIComponent(p)}&bu=${encodeURIComponent(bu)}&birthDate=${encodeURIComponent(birthDate)}`));
};
